const formData = require('form-data');
const Mailgun = require('mailgun.js');
const mailgun = new Mailgun(formData);

async function sendVerseToEmail(toEmail, verse, hasSubscribed) {


    const removeHTMLTags = function(text) {
        return text.replace(/<\/?[^>]+(>|$)/g, "");
    };

    const DOMAIN = 'mg1.mpen-international.com';
    const api_key = '';
    const mg = mailgun.client({
        username: 'api',
        key: process.env.MAILGUN_API_KEY || api_key,
        public_key: process.env.MAILGUN_PUBLIC_KEY || 'pubkey-b373d88ece2f713bf201c9412488cb33'
    });
    const verseFR = removeHTMLTags(verse.verseFR);
    const verseEN = removeHTMLTags(verse.verseEN);
    const year = "2026"
    const wishesFR = "Bonne année " + year
    const wishesEN = "Happy new year " + year
    const yourVerseFRDescription = "Ton verset de l'année "+ year
    const yourVerseENDescription = "Here is Your verse of the year " + year
    const data = {
        from: 'Verses MPEN-INTERNATIONAL <contact@mpen-international.com>',
        to: `${toEmail}`,
        subject: `Your verse of the year ${year} | Ton verset de l'année ${year} `,
        template: 'verseoftheyear',
        'h:X-Mailgun-Variables': `{"verseFR": "${verseFR}", "verseEN": "${verseEN}", "wishesFR": "${wishesFR}", "wishesEN": "${wishesEN}", "yourVerseFRDescription": "${yourVerseFRDescription}", "yourVerseENDescription": "${yourVerseENDescription}"}`
    };

    await mg.messages.create(DOMAIN, data);


    //Adding subscribed email to mailchimp
    console.log('has subscribed ' + hasSubscribed);
    if (hasSubscribed === true) {

        //Fast solution
        const dataSubscribed = {
            from: 'Verses MPEN-INTERNATIONAL <contact@mpen-international.com>',
            to: `mpensubscriptions@gmail.com`,
            subject: `New Subscription Throught Verse Of the Year`,
            text: toEmail,
        };

        mg.messages.create(DOMAIN, dataSubscribed).then(msg => console.log(msg)).catch(err => console.log(err));
    }
}

async function sendVerseToEmailSimple(toEmail, verse, hasSubscribed) {

    const DOMAIN = 'mg1.mpen-international.com';
    const api_key = '';
    const mg = mailgun.client({
        username: 'api',
        key: process.env.MAILGUN_API_KEY || api_key,
        public_key: process.env.MAILGUN_PUBLIC_KEY || 'pubkey-b373d88ece2f713bf201c9412488cb33'
    });

    const year = "2026";
    const wishesFR = "Bonne année " + year;
    const wishesEN = "Happy new year " + year;
    const yourVerseFRDescription = "Ton verset de l'année " + year;
    const yourVerseENDescription = "Your verse of the year " + year;

    // Build styled HTML email
    const htmlBody = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
        }
        .header {
            text-align: center;
            padding: 20px 0;
            border-bottom: 3px solid #022a4b;
            margin-bottom: 30px;
        }
        .header h1 {
            color: #022a4b;
            margin: 0;
        }
        .section {
            margin: 30px 0;
            padding: 20px;
            background-color: #f9f9f9;
            border-left: 4px solid #022a4b;
        }
        .section h2 {
            color: #022a4b;
            margin-top: 0;
        }
        .verse {
            font-size: 16px;
            line-height: 1.8;
            color: #555;
        }
        .footer {
            text-align: center;
            margin-top: 40px;
            padding-top: 20px;
            border-top: 1px solid #ddd;
            color: #888;
            font-size: 12px;
        }
    </style>
</head>
<body>
    <div class="header">
        <h1>${wishesEN} / ${wishesFR}</h1>
    </div>

    <div class="section">
        <h2>${yourVerseENDescription}</h2>
        <div class="verse">
            ${verse.verseEN}
        </div>
    </div>

    <div class="section">
        <h2>${yourVerseFRDescription}</h2>
        <div class="verse">
            ${verse.verseFR}
        </div>
    </div>

    <div class="footer">
        <p>MPEN International - Verses of the Year ${year}</p>
    </div>
</body>
</html>
    `;

    // Send email with HTML body (no template)
    const data = {
        from: 'Verses MPEN-INTERNATIONAL <versets@mg1.mpen-international.com>',
        to: `${toEmail}`,
        subject: `Your verse of the year ${year} | Ton verset de l'année ${year}`,
        html: htmlBody
    };

    await mg.messages.create(DOMAIN, data);

    console.log('Simple email sent to ' + toEmail);

    // Adding subscribed email to mailchimp
    console.log('has subscribed ' + hasSubscribed);
    if (hasSubscribed === true) {
        const dataSubscribed = {
            from: 'Verses MPEN-INTERNATIONAL <contact@mpen-international.com>',
            to: `mpensubscriptions@gmail.com`,
            subject: `New Subscription Through Verse Of the Year`,
            text: toEmail,
        };

        mg.messages.create(DOMAIN, dataSubscribed).then(msg => console.log(msg)).catch(err => console.log(err));
    }
}

module.exports = { sendVerseToEmail, sendVerseToEmailSimple };